export var CubePlane;
(function (CubePlane) {
    CubePlane["X"] = "x";
    CubePlane["Y"] = "y";
    CubePlane["Z"] = "z";
})(CubePlane || (CubePlane = {}));
export var Side;
(function (Side) {
    Side["L"] = "L";
    Side["R"] = "R";
    Side["U"] = "U";
    Side["D"] = "D";
    Side["F"] = "F";
    Side["B"] = "B";
})(Side || (Side = {}));
export var Modifier;
(function (Modifier) {
    Modifier["Double"] = "2";
    Modifier["CounterClockwise"] = "'";
    Modifier["Clockwise"] = "";
})(Modifier || (Modifier = {}));
